<template>
    <div>
        <div class="records-select">
            <span>{{ $t('orderStatus') }}：</span>
            <el-select v-model="recordsStatus" placeholder="请选择" style="width: 200px;">
                <el-option
                        v-for="item in recordsStatusOptions"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>

            <div class="block record-date">
                <span class="demonstration">{{ $t('orderDate') }}：</span>
                <el-date-picker
                        v-model="dateRange"
                        type="daterange"
                        align="right"
                        :placeholder="$t('selectDateRange')"
                        :picker-options="dateRangeOptions"
                        format="yyyy/MM/dd"
                        class="date-range-picker">
                </el-date-picker>
            </div>

            <el-button type="primary" @click="getRecords">{{ $t('search') }}</el-button>
        </div>

        <div class="store-content" v-loading.body="loading">
            <el-table
                    :data="recordsData"
                    :empty-text="loading ? ' ' : $t('noRecords')"
                    class="records-table" v-if="!loading">
                <el-table-column
                        prop="orderDate"
                        :label="$t('recordDate')"
                        width="180"
                        align="center">
                </el-table-column>
                <template v-if="recordsType == 'consume'">
                    <el-table-column
                            prop="appName"
                            :label="$t('appName')"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="goodsName"
                            :label="$t('goodsName')"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="goodsPrice"
                            :label="$t('goodsPrice')"
                            width="150"
                            align="center">
                    </el-table-column>
                </template>
                <template v-if="recordsType == 'recharge'">
                    <el-table-column
                            prop="channelName"
                            :label="$t('rechargeChannel')"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="rechargeAmount"
                            :label="$t('rechargeAmount')"
                            width="150"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="egPoint"
                            :label="$t('egPoint')"
                            width="110"
                            align="center">
                    </el-table-column>
                </template>
                <el-table-column
                        prop="orderId"
                        :label="$t('orderId')"
                        width="180"
                        align="center">
                </el-table-column>
            </el-table>
            <div class="records-btn" v-if="showRecordsBtn && !loading">
                <el-button type="primary" @click="getPreviewRecords" :disabled="disablePreview">{{ $t('previewPage') }}
                </el-button>
                <el-button type="primary" @click="getNextRecords" :disabled="disableNext">{{ $t('nextPage') }}
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {GET_RECORDS} from '../../store/mutation-types'

    export default {
        data() {
            return {
                loading: false,
                recordsStatus: '100',
                dateRange: '',
                page: 1
            }
        },
        computed: {
            disablePreview() {
                return this.page == 1;
            },
            disableNext() {
                return this.recordsData.length < 20;
            },
            showRecordsBtn() {
                return !this.disablePreview || !this.disableNext;
            },
            recordsType() {
                return this.$route.params.type;
            },
            recordsData() {
                if (this.recordsType === 'consume') {
                    return this.$store.getters.consumeRecordsList;
                }
                if (this.recordsType === 'recharge') {
                    return this.$store.getters.rechargeRecordsList;
                }
                return [];
            },
            startDate() {
                return this.formatData(0);
            },
            endDate() {
                return this.formatData(1);
            },
            dateRangeOptions() {
                return {
                    shortcuts: [{
                        text: this.$t('lastWeek'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: this.$t('lastMonth'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: this.$t('lastThreeMonth'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                }
            },
            recordsStatusOptions(){
                return [{
                    value: '0',
                    label: this.$t('statusPending')
                }, {
                    value: '100',
                    label: this.$t('statusSuccess')
                }, {
                    value: '-50',
                    label: this.$t('statusFail')
                }]
            }
        },
        methods: {
            formatData(num) {
                if (this.dateRange) {
                    let startDate = this.dateRange[num];
                    return startDate.getUTCFullYear() + "-" + (startDate.getUTCMonth() + 1) + "-" + startDate.getUTCDate()
                }
                return "";
            },
            getRecords() {
                this.loading = true;
                const that = this;
                let apiParams = {
                    recordsType: this.recordsType,
                    uid: this.$store.state.user.uid,
                    page: this.page,
                    recordsStatus: this.recordsStatus,
                    startDate: this.startDate,
                    endDate: this.endDate
                };

                this.$store.dispatch([GET_RECORDS], apiParams).then(() => {
                    that.loading = false;
                }).catch((errorCode) => {
                    that.loading = false;
                    if (errorCode === -1) {
                        that.$message.error(that.$t('systemErrorTryLater'));
                    } else {
                        that.$message.error('Get records failed: ' + errorCode);
                    }
                });
            },
            getPreviewRecords() {
                if (this.page > 1) {
                    this.page = this.page - 1;
                    this.getRecords();
                }
            },
            getNextRecords() {
                this.tableData = [];
                this.page = this.page + 1;
                this.getRecords();
            }
        },
        created() {
            this.getRecords();
        },
        watch: {
            '$route' (to, from) {
                this.recordsType = to.params.type;
                this.recordsData = [];
                this.recordsStatus = '100';
                this.dateRange = '';
                this.page = 1;
                this.getRecords();
            }
        }
    }
</script>


<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../../assets/scss/lib";

    .store-content {
        background: none;
        border: none;
        padding: 0;
        min-height: 500px;
    }

    .record-date {
        margin: 0 50px;
    }

    .records-select {
        @include flex-row-center;
        margin: 10px auto 50px;
    }

    .records-table {
        margin: 0 auto;
    }

    .date-range-picker {
        width: 220px;
    }

    .records-btn {
        margin-top: 35px;
        align-self: flex-end;
        margin-right: 25px;
    }

    .el-button {
        width: 85px;
    }
</style>



// WEBPACK FOOTER //
// Records.vue?1d344213